var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "account", title: "Account Terms" } },
    [
      _c("template", { slot: "copy" }, [
        _c(
          "ol",
          {
            staticClass: "fa-ul",
            staticStyle: {
              "--fa-li-width": "4em",
              "--margin-bottom": "var(--spacing-2xl)",
              "--margin-top": "var(--spacing-2xl)",
            },
          },
          [
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa1 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You must be 13 years or older to use this Service.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa2 },
                  }),
                ],
                1
              ),
              _vm._v(
                '\n        You must be a human. Accounts registered by "bots" or other automated methods are not permitted.\n      '
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa3 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You must provide your name, a valid email address, and any other information requested in order to complete the registration process.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa4 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        Your login may only be used by one person - i.e., a single login may not be shared by multiple people - except that a machine user's actions may be\n        directed by multiple people.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa5 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You are responsible for maintaining the security of your account and password. Font Awesome cannot and will not be liable for any loss or damage from\n        your failure to comply with this security obligation.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa6 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You are responsible for all activity that occurs under your account.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa7 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        One person or legal entity may not maintain more than one free account, and one machine user account that is used exclusively for performing automated\n        tasks.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa8 },
                  }),
                ],
                1
              ),
              _vm._v(
                "\n        You may not use the Service for any illegal or unauthorized purpose. You must not, in the use of the Service, violate any laws in your jurisdiction\n        (including but not limited to copyright or trademark laws).\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "margin-bottom-md" },
              [
                _c(
                  "span",
                  {
                    staticClass: "fa-li",
                    staticStyle: { color: "var(--fa-gravy)" },
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: _vm.parent.$v6.regular.fa9 },
                    }),
                  ],
                  1
                ),
                _vm._v(
                  "\n        Your use of the Service is conditioned upon your payment of certain fees to Font Awesome (the “User Fees”). Such User Fees are specifically set forth\n        here:\n        "
                ),
                _c("site-link", { attrs: { to: { name: "kits" } } }, [
                  _vm._v("https://fontawesome.com/plans"),
                ]),
                _vm._v(
                  " (the “Plans Page”). You shall pay the applicable User Fee, depending on\n        the plan that you select and including any additional fees associated with metered billing usage, to Font Awesome as a strict condition of these Terms\n        of Service. In the event any User Fee, including any fees associated with metered billing, is not timely received by Font Awesome, any license granted\n        to you by Font Awesome, including any rights contained in the Font Awesome Pro License, shall immediately terminate, except as expressly set forth in\n        any document granting such license.\n      "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.majorVersionIsGreaterThan6
              ? _c("li", { staticClass: "margin-bottom-md" }, [
                  _c(
                    "span",
                    {
                      staticClass: "fa-li",
                      staticStyle: { color: "var(--fa-gravy)" },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: _vm.parent.$v6.regular.fa1 },
                      }),
                      _c("font-awesome-icon", {
                        attrs: { icon: _vm.parent.$v6.regular.fa0 },
                      }),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n        The specific elements of the Service to which you have and do not have access depend on the plan that you select, as described on the Plans Page. If\n        you selected, and maintain, a plan that was created prior to the creation of our Pro Lite+, Pro+, and ProMax+ plans, such plan may not have access to\n        certain features, including “Pro+” icons. The features accessible by each plan are fully described by the Plans Page.\n      "
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }